import React from "react";
import { useEffect, useContext, useState } from "react";
import { MapContainer, TileLayer, GeoJSON } from "react-leaflet";
import { Backdrop, CircularProgress } from "@material-ui/core";
import { makeStyles } from "@material-ui/core/styles";
import { AppContext } from "../AppContext";
import MapDialog from "../components/MapDialog";
import MapZoomOut from "../components/MapZoomOut";
import MapFlyBtn from "../components/MapFlyBtn";
import MapInfo from "../components/MapInfo";
import Goodbye from "../components/Goodbye";

const useStyles = makeStyles({
  high: {
    zIndex: 2000,
  },
});

const Mapa = React.memo(() => {
  const classes = useStyles();
  const [loading, setLoading] = useState(true);
  const [open, setOpen] = useState(false);
  const [snackPack, setSnackPack] = useState([]);
  const { mapData, setMapData } = useContext(AppContext);

  const openSnackBar = (message, cases) => {
    setSnackPack((prev) => [
      ...prev,
      { message, key: new Date().getTime(), cases: cases },
    ]);
  };

  const handleClose = () => {
    setOpen(false);
  };

  useEffect(() => {
    openSnackBar("Click en el mapa!", null);
    const fetchGeojson = async () => {
      if (mapData) return;

      const res = await fetch(
        "https://api-sinaloa-covid-app.netlify.app/map-compressed.json"
      );
      let data = await res.json();
      setMapData(data);
      console.log(data);
    };
    fetchGeojson();
  }, [mapData, setMapData]);

  const initialPos = {
    center: [24.8049008, -107.4933546],
    zoom: 6.5,
  };

  return (
    <>
      <Goodbye />
      {(!mapData || loading) && (
        <Backdrop open={true} className={classes.high}>
          <CircularProgress color="primary" className={classes.high} />
        </Backdrop>
      )}
      <MapContainer
        style={{
          flexGrow: 1,
        }}
        preferCanvas={true}
        center={initialPos.center}
        zoom={initialPos.zoom}
        zoomControl={false}
        whenReady={() => setLoading(false)}
      >
        <TileLayer
          attribution='&copy; <a href="http://cartodb.com/attributions" target="_blank">CartoDB</a>'
          url="https://{s}.basemaps.cartocdn.com/rastertiles/light_nolabels/{z}/{x}/{y}.png"
        />
        {mapData && (
          <GeoJSON
            data={mapData}
            onEachFeature={(feature, layer) => {
              layer.bindTooltip(feature.properties.name, {
                permament: false,
                direction: "center",
              });
              layer.on("click", (e) => {
                layer.openTooltip();
                openSnackBar(
                  feature.properties.name,
                  feature.properties.amountActive
                );
              });
              layer.removeEventListener("mouseover");
              layer.removeEventListener("mouseout");
            }}
            style={(geoJsonFeature) => {
              return { color: geoJsonFeature.properties.color };
            }}
          />
        )}
        <MapZoomOut initialPos={initialPos} />
        <MapInfo snackPack={snackPack} setSnackPack={setSnackPack} />
        <MapFlyBtn setOpen={setOpen} />
        <MapDialog open={open} handleClose={handleClose} />
      </MapContainer>
    </>
  );
});

export default Mapa;
